import { Box, Dialog, Stack, styled, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

import { colors } from '../../components/theme/theme';

export const LogoContainer = styled(Stack)(() => ({
    marginTop: 24,
    marginBottom: 24,
}));

export const BrandLogoStyle = {
    height: '100%',
    width: '100%',
    maxHeight: 60,
    maxWidth: 188,
};

export const LoginCardStack = styled(Stack)<{ $currentStep: string }>(({ $currentStep }) => ({
    maxWidth: $currentStep === 'password' ? '800px !important' : '458px !important',
}));

export const FormFieldsContainer = styled(Box)(() => ({
    marginBottom: 24,
    width: '100%',
}));

export const FullWidthFieldWrapper = styled(Box)(() => ({
    marginBottom: 16,
    width: '100%',
}));

export const FieldWrapper = styled(Box)(() => ({
    marginBottom: 16,
    textAlign: 'left',
}));

export const EmailFieldWrapper = styled(Box)(() => ({
    textAlign: 'left',
}));

export const CenteredTypography = styled(Typography)(() => ({
    textAlign: 'center',
}));

export const DescriptionText = styled(Typography)(() => ({
    textAlign: 'center',
    marginBottom: 12,
}));

export const HintText = styled(Typography)(() => ({
    textAlign: 'center',
    marginBottom: 4,
}));

export const LastHintText = styled(Typography)(() => ({
    textAlign: 'center',
    marginBottom: 24,
}));

export const VerificationTitle = styled(Typography)<{ component?: React.ElementType }>(() => ({
    textAlign: 'center',
    marginBottom: 16,
}));

export const SuccessMessage = styled(Typography)(() => ({
    textAlign: 'center',
    marginBottom: 24,
    color: colors.greyPreset[80],
}));

export const SupportLinksStack = styled(Stack)(() => ({
    paddingTop: 24,
    gap: 8,
    alignItems: 'center',
}));

export const SupportText = styled(Typography)(() => ({
    textAlign: 'center',
    color: colors.greyPreset[80],
}));

/** Use with sx={LoginLinkText} – MUI passes theme when sx is a function. */
export const LoginLinkText = (theme: Theme) => ({ ...theme.typography.body2 });

export const FooterLinksContainer = styled(Box)(() => ({
    textAlign: 'center',
    marginTop: 16,
}));

export const FooterTypography = styled(Typography)(() => ({
    color: colors.greyPreset[80],
}));

/** Use with sx={FooterLinkText} – MUI passes theme when sx is a function. */
export const FooterLinkText = (theme: Theme) => ({ ...theme.typography.caption, fontWeight: 400 });

export const SeparatorText = styled(Typography)(() => ({
    paddingLeft: '6px',
    paddingRight: '6px',
}));

export const ModalContentStack = styled(Stack)(() => ({
    gap: 24,
    marginBottom: 8,
    marginTop: 16,
    textAlign: 'center',
}));

export const StyledDialog = styled(Dialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: 16,
        padding: 24,
        maxWidth: '400px',
        width: '100%',
    },
}));

/** Dark navy link colour shared with the merged login screen (same on hover/visited/active). */
export const NavyLinkColor = {
    color: colors.bluePreset[10],
    '&:hover, &:visited, &:active': { color: colors.bluePreset[10] },
    '&:hover': { textDecoration: 'underline' },
};

/** Bold navy action link (e.g. "Contact Support", "Log In"). */
export const NavyActionLinkText = (theme: Theme) => ({
    ...theme.typography.body2,
    fontWeight: 700,
    ...NavyLinkColor,
});
